import type { HouseholdIncome } from '@hc-frontend/core-types';

export function formatIncome(householdIncome?: HouseholdIncome) {
  if (householdIncome === undefined) {
    return null;
  }

  return Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  }).format(householdIncome as number);
}
